const translations = {
    creatingQuickBooksInvoiceErrorMessage: 'Error creating QuickBooks® invoice',
    creatingQuickBooksInvoiceSuccessMessage: 'QuickBooks® invoice created successfully',
    fetchingQuickBooksInvoiceErrorMessage: 'Error fetching QuickBooks® invoice',
    fetchingQuickBooksInvoicePdfErrorMessage: 'Error fetching QuickBooks® invoice PDF',
    fetchingQuickBooksInvoiceServiceItemsErrorMessage:
        'Error fetching QuickBooks® invoice service items',
    fetchingQuickBooksInvoiceTaxesErrorMessage: 'Error fetching QuickBooks® invoice taxes',
    fetchingQuickBooksInvoiceTermsErrorMessage: 'Error fetching QuickBooks® invoice terms',
    fetchingQuickBooksInvoicesErrorMessage: 'Error fetching QuickBooks® invoices',
    sendingQuickBooksInvoiceErrorMessage: 'Error sending QuickBooks® invoice',
    sendingQuickBooksInvoiceSuccessMessage: 'QuickBooks® invoice sent successfully',
    updatingQuickBooksInvoiceErrorMessage: 'Error updating QuickBooks® invoice',
    updatingQuickBooksInvoiceSuccessMessage: 'QuickBooks® invoice updated successfully'
};

export default translations;
